import {gql} from "@irati/utils/gql"

export default gql`
  fragment fullBranding on Branding {
    uuid
    businessId
    teamId
    businessLogoUrl
    businessSquareLogoUrl
    hasPartnerLogo
    isEnabled
    primaryColour
    textColour
    welcomeEmail
  }
`
